<lib-modal-layout [title]="title()" subtitle="">
  <form [formGroup]="form">
    @switch (data.policyChangeType) {
      @case ('Other') {
        <div class="flex flex-col">
          <div class="w-full">
            <lib-custom-date-picker
              label="Effective Date"
              formControlName="otherEffectiveDate"
            ></lib-custom-date-picker>
          </div>
          <div class="w-full">
            <lib-form-text-area label="Endorsement Description" formControlName="description"
              [rows]="5">
            </lib-form-text-area>
          </div>
          <div class="w-full">
            <lib-form-dropdown label="Amendment Changes to Premium" formControlName="amendment" [options]="amendmentTypes">
            </lib-form-dropdown>
          </div>
          @if (authStore.isAdmin()
            && (otherForm.get('amendment')?.value === 'Additional Premium' || otherForm.get('amendment')?.value === 'Return Premium')) {
            <div
              class="w-full">
              <lib-form-money label="Amount" formControlName="amount" [allowDecimals]="true">
              </lib-form-money>
            </div>
          }
          <div>
            @if (this.mode === 'add') {
              <div>
                <lib-form-file-attachment
                  label="PDF Forms in addition to IL1201"
                  formControlName="file"
                  [acceptedFormats]="['pdf', 'doc', 'docx']">
                </lib-form-file-attachment>
              </div>
            }
          </div>
        </div>
      }
      @case ('Reinstatement') {
        <div class="flex flex-col">
          <div class="w-full">
            <lib-form-dropdown label="Reinstatement Reason" formControlName="reinstatementReason"
            [options]="lookupStore.reinstatementReasons()!"></lib-form-dropdown>
          </div>
          <div class="w-full">
            <lib-form-text-area label="Notes" formControlName="reinstatementNotes" [rows]="5"></lib-form-text-area>
          </div>
        </div>
      }
      @default {
        <div class="flex flex-col">
          @if (authStore.isAdmin()) {
            <div class="w-full">
              <lib-form-dropdown label="Cancellation Type" formControlName="typeOfEndorsement" [options]="cancellationTypes">
              </lib-form-dropdown>
            </div>
          }
          <div class="w-full">
            <lib-form-dropdown label="Cancellation Reason" formControlName="cancellationReason"
            [options]="lookupStore.cancellationReasons()!"></lib-form-dropdown>
          </div>
          @if (cancellationForm.controls['typeOfEndorsement']?.value !== 18) {
            <div class="w-full">
              <lib-custom-date-picker
                label="Effective Date"
                formControlName="cancellationEffectiveDate">
              </lib-custom-date-picker>
            </div>
          }
          <div class="w-full">
            <lib-form-text-area label="Notes" formControlName="cancellationNotes" [rows]="5"></lib-form-text-area>
          </div>
        </div>
      }
    }

    @if (!authStore.isAdmin()) {
      <lib-button
        btnPrimary
        [cssType]="'btn-primary'"
        [disabled]="mode === 'view'"
        [icon]="'rightarrow'"
        [text]="'Submit'"
        [type]="'submit'"
        (click)="onSubmit()"
      ></lib-button>
    }

    @if (authStore.isAdmin()) {
      <div
        class="flex items-center justify-center gap-3">
        <div>
          <lib-button (click)="onIssue()" [buttonType]="'button'" [cssType]="'btn-primary'"
            [text]="'Issue'" [disabled]="mode === 'view'">
          </lib-button>
        </div>
        @if (mode === 'edit') {
          <div>
            <lib-button (click)="onDecline()" [buttonType]="'button'" text="Decline" [cssType]="'btn-secondary'">
            </lib-button>
          </div>
        }
      </div>
    }
  </form>
</lib-modal-layout>